<div class="main-content">
    <div class="home">

        <div class="row">
            <div class="col-md-12">
                <!--<div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">-->
                <div>
                    <h1 class="h3 mb-0 text-gray-800" style="margin: 0 0 -15px 0;">Home </h1>
                    <i *ngIf="announcements.length > 0" class="far fa-bell bell bellRed pointer" (click)="showAnnouncementsModal()"></i>
                    <!--<i [popover]="esr" class="fas fa-question-circle pointer"></i>-->
                    <!--<popover-content #esr
                 title="Home"
                 placement="right"
                 [animation]="true"
                 [closeOnClickOutside]="true">
                    <p>Home</p>
                </popover-content>-->
                </div>
            </div>
        </div>

        <!--<ng-container *ngIf="loading">
        <div class="text-center">
            <br />
            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
            <br />
            <p>Loading, please wait...</p>
        </div>
    </ng-container>-->

        <ng-template #load>
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                <p>Loading, please wait...</p>
            </div>
        </ng-template>

        <div class="row"></div>

        <div class="quickMenu" style="top: 10px;right: 67px;">
            <div class="dropdown">
                <a class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" data-toggle="dropdown">
                    <span class="button-text"> Actions </span> <i class="fas fa-caret-down" style="vertical-align: unset;"></i>
                </a>
                <ul class="dropdown-menu">
                    <!--<li><a (click)="getUserPersonalData()">Purchase assessments</a></li>-->
                    <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-self-assessment-1&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase Self assessments</a></li>
                    <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-360-assessment&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase 360 assessments</a></li>
                    <li><a (click)="openAssignModal()">Assign assessments</a></li>
                </ul>
            </div>
        </div>


        <!------------------->
        <!-----carousel tiles------>
        <!------------------->
        <div class="container-fluid noPadding spacing" style="margin: 0 -15px;">
            <div id="carouselMovil" class="container-fluid">
                <div class="movilWrap">
                    <!--<div style="min-width: 35px !important;"></div>-->
                    <div class="" *ngFor="let tile of mediaJSON.tiles">
                        <div class="card mb-2 noPadding" style="max-width: 230px;">
                            <div class="img-wrap pointer" (click)="showVideoModal(tile.title, tile.description, tile.videoUrl)">
                                <img class="card-img-top" src="../../../assets/img/Video_thumbnail_coaching_logo.png" alt="Card image cap">
                                <i class="far fa-play-circle hvr-bounce-in"></i>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title noPadding">{{tile.title}}</h5>
                                <p class="card-text" >
                                    {{tile.description}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--<div style="min-width: 0px !important; padding:0;">
                        <a (click)="scrollLeft()" class="left carousel-control"><i class="fas fa-chevron-left"></i></a>
                        <a (click)="scrollRight()" class="right carousel-control"><i class="fas fa-chevron-right"></i></a>
                    </div>-->
                </div>
                <!--<button (click)="scrollLeft()" id="slideBack" type="button">Prev</button>
                <button (click)="scrollRight()" id="slide" type="button">Next</button>-->
            </div>
        </div>
        <!------------------->
        <!-----carousel tiles------>
        <!------------------->


        <div *ngIf="false" class="row box-container" style="display:inline;">
            <div class="col-12 col-sm-6 col-md-3" style="padding-left: 0; text-align:-webkit-center;">
                <div class="shadow box">
                    <div class="card homeCard shadow blueShadow">
                        <div class="card-container">
                            <div class="header">
                                <select #assessmentRegular (change)="getCoachTotals(assessmentRegular.value, false)">
                                    <option value="Available">Available</option>
                                    <option value="Assigned">Assigned</option>
                                    <option value="Completed">Completed</option>
                                </select>
                            </div>
                            <div class="content">
                                <!--<div class="icon">
                                <i class="fas fa-edit"></i>
                            </div>-->
                                <div class="count blue">
                                    <span *ngIf="!loaded">{{counter}}</span>
                                    <span *ngIf="loaded">{{assessmentsRegular}}</span>
                                </div>
                                <div class="name blue">
                                    <span>ELI Assessments</span>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="actions">
                                    <a (click)="openAssignModal()">Assign</a>
                                    <a (click)="openPurchaseModal()">Purchase</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3" style="padding-left: 7px; text-align: -webkit-center">
                <div class="shadow box">
                    <div class="card homeCard shadow greenShadow">
                        <div class="card-container">
                            <div class="header">
                                <select #assessment360 (change)="getCoachTotals(assessment360.value, true)">
                                    <option value="Available">Available</option>
                                    <option value="Assigned">Assigned</option>
                                    <option value="Completed">Completed</option>
                                </select>
                            </div>
                            <div class="content">
                                <!--<div class="icon">
                                <img src="../../../assets/img/icon360.png" alt="Alternate Text" />
                                <i class="fas fa-globe"></i>
                            </div>-->
                                <div class="count green">
                                    <span *ngIf="!loaded">{{counter}}</span>
                                    <span *ngIf="loaded">{{assessments360}}</span>
                                </div>
                                <div class="name green">
                                    <span>360 Assessments</span>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="actions">
                                    <a (click)="openAssignModal()">Assign</a>
                                    <a (click)="openPurchaseModal()">Purchase</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3" style="padding-left: 7px; text-align: -webkit-center">
                <div class="shadow box">
                    <div class="card homeCard shadow orangeShadow">
                        <div class="card-container">
                            <div class="header"></div>
                            <div class="content">
                                <!--<div class="icon">
                                <i class="fas fa-users"></i>
                            </div>-->
                                <div class="count orange">
                                    <span *ngIf="!loaded">{{counter}}</span>
                                    <span *ngIf="loaded">{{clientsAmount}}</span>
                                </div>
                                <div class="name orange">
                                    <span>Clients</span>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="actions">
                                    <a (click)="goTo('/app/clients')">View</a>
                                    <a (click)="showAddClientModal(1)">Add</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3" style="padding-left: 7px; padding-right: 0; text-align: -webkit-center">
                <div class="shadow box">
                    <div class="card homeCard shadow yellowShadow">
                        <div class="card-container">
                            <div class="header"></div>
                            <div class="content">
                                <!--<div class="icon">
                                <i class="fas fa-envelope-open-text"></i>
                            </div>-->
                                <div class="count yellow">
                                    <span *ngIf="!loaded">{{counter}}</span>
                                    <span *ngIf="loaded">{{emails}}</span>
                                </div>
                                <div class="name yellow">
                                    <span>Email Templates</span>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="actions">
                                    <a (click)="goTo('/app/cemails')">View</a>
                                    <a></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- OLD HOME END -->

        <!--<div>
            <button (click)="ssoShopify()">SSO</button>
            <div id="ssoContent"></div>
        </div>-->

        <!--<div>
            <form id="shopifyForm" action="https://community.ipeccoaching.com/sso-eli-shopify/" method="post" enctype="multipart/form-data">
                <input type="text" name="contact_id" value="" hidden>
                <input type="email" name="user_email" value="" hidden>
                <input type="text" name="first_name" value="" hidden>
                <input type="text" name="last_name" value="" hidden>-->
                <!--<input type="submit" value="SSO-Redirect" (click)="ssoToShopify()">-->
            <!--</form>
        </div>-->

        <!--NEW HOME-->
        <div class="homeTiles">
            <div class="relative">
                <!--<div class="col-xs-12 col-sm-6 col-md-6 absolute" id="tile1">-->
                <!--<div class="bigBox blueBox mR15" (click)="openPurchaseModal()">-->
                <!--<a target="_blank" href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-self-assessment-1&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==">
                    <div class="bigBox blueBox mR15">-->
                            <!--(click)="getUserPersonalData()">-->
                            <!--<div>
                                <div class="boxIcon hideonHover">
                                    <i class="pe-7s-note2"></i>
                                </div>
                                <div class="boxLabel">
                                    <p>Purchase Assessments</p>
                                </div>

                                <div class="showOnHover">
                                    <p>Purchase ELI and ELI 360 Assessments, so you can assign them to your clients.</p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>-->

                <div class="col-xs-12 col-sm-6 col-md-6 absolute" id="tile1">
                    <div class="col-xs-12 col-sm-12 col-md-12 mixedTop">
                        <a target="_blank" href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-self-assessment-1&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==">
                            <div class="mediumBox blueBox customMargin">
                                <div class="linealBox">
                                    <div class="boxIcon hideonHover">
                                        <i class="pe-7s-note2"></i>
                                    </div>
                                    <div class="boxLabel">
                                        <p>&nbsp; Purchase Self Assessments</p>
                                    </div>

                                    <div class="showOnHover">
                                        <p>Purchase ELI Assessments, so you can assign them to your clients.</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 mixedBottom">
                        <a target="_blank" href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-360-assessment&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==">
                            <div class="mediumBox whiteBox customMargin">
                                <div class="linealBox">
                                    <div class="boxIcon hideonHover">
                                        <i class="pe-7s-note2"></i>
                                    </div>
                                    <div class="boxLabel">
                                        <p>&nbsp; Purchase 360 Assessments</p>
                                    </div>

                                    <div class="showOnHover">
                                        <p>Purchase ELI 360 Assessments, so you can assign them to your clients.</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 absolute" id="tile2">
                    <div class="bigBox whiteBox" (click)="openAssignModal()">
                        <div>
                            <!--<div class="boxCount"><span>2</span></div>-->
                            <div class="boxIcon hideonHover">
                                <i class="pe-7s-note"></i>
                            </div>
                            <div class="boxLabel">
                                <p>Assign Assessments</p>
                            </div>

                            <div class="showOnHover">
                                <p>Assign your purchased Standard and 360 ELI assessments to your clients.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="relative">
                <div class="col-xs-12 col-sm-6 col-md-6 absolute" id="tile3">
                    <!--//220-->
                    <div class="bigBox whiteBox mR15" (click)="goTo('/app/clients')">
                        <div>
                            <div class="boxIcon hideonHover">
                                <i class="pe-7s-users"></i>
                            </div>
                            <div class="boxLabel">
                                <p>Manage Clients</p>
                            </div>

                            <div class="showOnHover">
                                <p>Add a new client so you can assign them ELI assessments.</p>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 absolute" id="tile4">
                    <div class="col-xs-12 col-sm-12 col-md-12 mixedTop">
                        <div class="mediumBox blueBox" (click)="goTo('/app/coach_assessments')">
                            <div class="linealBox">
                                <div class="boxIcon hideonHover">
                                    <i class="pe-7s-news-paper"></i>
                                </div>
                                <div class="boxLabel">
                                    <p>&nbsp; View Assessment Reports</p>
                                </div>

                                <div class="showOnHover">
                                    <p>Click here to access the reports for the completed assessments</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 mixedBottom">
                        <div class="mediumBox whiteBox" (click)="goTo('/app/cemails')">
                            <div class="linealBox">
                                <div class="boxIcon hideonHover">
                                    <i class="pe-7s-mail-open-file"></i>
                                </div>
                                <div class="boxLabel">
                                    <p>&nbsp; Email Templates</p>
                                </div>

                                <div class="showOnHover">
                                    <p>Customize the standard email templates use to communicate about ELI with your clients.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--NEW HOME END-->

    </div>
</div>

<!--/*CUSTOMIZE MODAL*/-->
<div id="customizeModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h2 class="modal-title text-center">Standard Templates</h2>
                    <button type="button" class="close" (click)="closeCustomizeModal()" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>

            <div class="modal-body">
                <div>
                    <div style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="standardData"
                                         [columnDefs]="standardDataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onStandardRowClicked($event)"
                                         (gridReady)="onStandardGridReady($event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [rowSelection]="rowSelection"
                                         [rowMultiSelectWithClick]="true"
                                         [suppressRowClickSelection]="true">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeCustomizeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <!--<button type="button" class="btn btn-primary">Ok</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*ASSIGN MODAL*/-->
<div id="assignModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Assign Assessments</h2>
                <button type="button" class="close" (click)="hideAssignModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <!--AG GRID Assessments-->
                <div [ngClass]="{'display': currentPage == 1}" class="displayNone">
                    <h5>Assessments</h5>

                    <div class="assessmentTabs">
                        <ul class="tab-nav" id="assessmentTypes">
                            <li (click)="selectedTab(1)" class="active"><a data-toggle="tab" href="#Tab1">ELI - Self Assessment</a></li>
                            <li (click)="selectedTab(2)"><a data-toggle="tab" href="#Tab2">ELI 360</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="Tab1" class="tab-pane fade in active">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #assessmentsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="assessmentsGridOptions"
                                                 [rowData]="assessmentsELIData"
                                                 [columnDefs]="assessmentsHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onAssessessmentRowClicked($event)"
                                                 (gridReady)="onGridReady(1,$event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="assessmentsRowSelection"
                                                 (selectionChanged)="onAssessmentsSelectionChanged(1, $event)">
                                </ag-grid-angular>
                            </div>
                        </div>

                        <div id="Tab2" class="tab-pane fade">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #assessmentsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="assessmentsGridOptions"
                                                 [rowData]="assessments360Data"
                                                 [columnDefs]="assessmentsHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onAssessessmentRowClicked($event)"
                                                 (gridReady)="onGridReady(2,$event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="assessmentsRowSelection"
                                                 (selectionChanged)="onAssessmentsSelectionChanged(2, $event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="hideAssignModal()" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="openAssignModal()" type="button" class="btn btn-primary">Next</button>

                        <!--<button *ngIf="currentPage >= 2" (click)="prevContent()" type="button" class="btn btn-primary">Previous</button>
                        <button *ngIf="currentPage < 5" (click)="nextContent()" type="button" class="btn btn-primary" [disabled]="!enoughAmount">Next</button>
                        <button *ngIf="currentPage == 5" (click)="confirmationSave()" [disabled]="saving" type="button" class="btn btn-primary">Finish</button>-->

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--PURCHASE MODAL-->
<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<!--raters types-->
<app-rater-types-for-modal #raterTypesForModal></app-rater-types-for-modal>
<app-assign-assessment-modal #assignAssessment></app-assign-assessment-modal>


<!--/*Add client modal*/-->
<div id="caddClientModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{action}} Client</h2>
                <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-3">
                        <label><b style="color:#000;">Email: </b></label>
                    </div>
                    <div class="col-xs-9">
                        <input email placeholder="Email" #email (keypress)="preventSpace(email.value, $event, 'cemail')" type="email" value="" id="cemail" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-3">
                        <label><b style="color:#000;">First Name: </b></label>
                    </div>
                    <div class="col-xs-9">
                        <input placeholder="First Name" #name (keypress)="preventSpace(name.value, $event, 'cname')" type="text" value="" id="cname" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-3">
                        <label><b style="color:#000;">Last Name: </b></label>
                    </div>
                    <div class="col-xs-9">
                        <input placeholder="Last Name" #last (keypress)="preventSpace(last.value, $event, 'clast')" type="text" value="" id="clast" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button [disabled]="savingClient" (click)="addClient(email.value, name.value, last.value)" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*PREVIEW MODAL*/-->
<div id="previewModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h2 class="modal-title text-center">Email Template Preview</h2>
                    <button (click)="closePreviewModal();" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="text-right" style="text-align:right;">
                    <a *ngIf="!customize" (click)="customizeTemplate()" class="d-none d-sm-inline-block btn btn-primary btn-sm shadow-sm margin-right-5">
                        <i class="fas fa-pencil-alt text-white-50"> <span class="button-text"> Customize</span></i>
                    </a>
                    <a *ngIf="customize" (click)="updateEmailTemplate(_name.value, _type.value, _purpose.value, _userType.value)" class="d-none d-sm-inline-block btn btn-primary btn-sm shadow-sm margin-right-5">
                        <i class="fas fa-save text-white-50"> <span class="button-text"> Save</span></i>
                    </a>
                </div>
            </div>

            <div class="modal-body">
                <div id="notCustomizable">
                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label for="subject">Subject: </label>
                        </div>
                        <div class="col-md-10">
                            <input class="input_readonly" readonly type="text" name="subject" id="prevSubject" value="" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label for="body">Body: </label>
                        </div>
                        <div class="col-md-10">
                            <div class="bodyContainer input_readonly" id="body"></div>
                        </div>
                    </div>
                </div>
                <div id="customizable" class="displayNone">
                    <!--<div class="row">
                        <div class="col-md-2 text-right">
                            <label for="subject">Subject: </label>
                        </div>
                        <div class="col-md-10">
                            <input type="text" name="subject" id="csubject" value="" />
                        </div>
                    </div>-->


                    <div class="row">
                        <div class="col-md-2">
                            <label>Name: </label>
                        </div>
                        <div class="col-md-10">
                            <input #_name type="text" id="emailTemplateName" value="{{name}}" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Assessment type: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aType" #_type>
                                <!--(change)="getSelectedOptionText($event)"-->
                                <option *ngFor="let _type of types" [selected]="type == _type.Id" value="{{_type.Id}}">{{_type.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <!--<div class="row">
                        <div class="col-md-2">
                            <label>Niche: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aNiche" #_niche>
                                <option *ngFor="let _niche of niches" [selected]="niche == _niche.Id" value="{{_niche.Id}}">{{_niche.Name}}</option>
                            </select>
                        </div>
                    </div>-->

                    <div class="row">
                        <div class="col-md-2">
                            <label>User Type: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aUserType" #_userType>
                                <option *ngFor="let _usertype of userTypes" [selected]="userType == _usertype.Id" value="{{_usertype.Id}}">{{_usertype.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Purpose: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="aPurpose" #_purpose>
                                <option disabled class="input_readonly" *ngFor="let _purpose of purposes" [selected]="purpose == _purpose.Id" value="{{_purpose.Id}}">{{_purpose.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Language: </label>
                        </div>
                        <div class="col-md-10">
                            <select disabled class="input_readonly" id="alanguages" #_languageShortCode (change)="checkData(_languageShortCode.value, _subject.value)" (focusin)="addLocalization(_languageShortCode.value, _subject.value )">
                                <option *ngFor="let _language of languages" [selected]="_language == 'en'" class="option" value="{{_language.ShortCode}}">{{_language.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <label>Subject: </label>
                        </div>
                        <div class="col-md-10">
                            <input #_subject
                                   (keypress)="preventSpace(_subject.value, $event, 'csubject')"
                                   (keyup)="preventSpace(_subject.value, $event, 'csubject')"
                                   type="text"
                                   id="csubject" value=""
                                   placeholder="Subject" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8">
                            <div class="body-content">
                                <br />
                                <quill-editor #editor
                                              [(ngModel)]="editorContent"
                                              (blur)="onEditorBlured($event)"
                                              (focus)="onEditorFocused($event)"
                                              (onEditorCreated)="onEditorCreated($event)"
                                              (onContentChanged)="onContentChanged($event)"></quill-editor>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="customFields">
                                <div class="panel-group" id="accordion">

                                    <div *ngFor="let field of templateFields; let i = index" class="panel panel-default">
                                        <div class="panel-heading" data-toggle="collapse">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" data-parent="#accordion" href="#group{{i}}">{{field.Name}} Details</a>
                                            </h4>
                                        </div>
                                        <div id="group{{i}}" class="panel-collapse collapse" [ngClass]="{'in': i == 0}">
                                            <div class="panel-body">
                                                <ul>
                                                    <li *ngFor="let item of field.Fields">
                                                        <button [disabled]="isStandard" (click)="insertCustomFields(item.Name)">{{item.Name}}</button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button *ngIf="customize" (click)="closePreviewModal();" style="margin-right: 25px;" type="button" data-dismiss="modal" class="btn btn-secondary">Close</button>
                        <!--<button *ngIf="customize" style="margin-right: 25px;" type="button" class="btn btn-secondary">Ok</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--IMPORT CLIENT MODAL-->
<div id="importModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 *ngIf="importType == 1; else imporType2" class="modal-title text-center">Import Clients</h2>
                <ng-template #imporType2>
                    <h2 class="modal-title text-center">Import Raters</h2>
                </ng-template>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="iFile" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12" style="padding: 0 25px;">
                        <button (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="okImportClients()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--video MODAL-->
<div id="videoModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="height: 100vh;">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{videoModalTitle}}</h2>
                <button (click)="closeVideoModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="text-center">
                    <p style="margin:0px;">{{videoModalDescription}}</p>
                </div>
            </div>

            <div class="modal-body video-container" style="height: calc(100% - 177px);">
                <!--<iframe width="100%" height="100%" src="https://www.youtube.com/embed/uShl2lwzAbU?controls=0"
                        frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                </iframe>-->
                <!--<video width="100%" height="100%" controls>
                    <source [src]="currentVideoUrl" type="video/mp4">
                    Your browser does not support the video tag.
                </video>-->
            </div>

            <div class="modal-footer">
                <div class="text-center">
                    <div class="col-md-12">
                        <button (click)="closeVideoModal()" style="min-width: 145px;" data-dismiss="modal" type="button" class="btn btn-secondary">Close</button>
                        <!--<button (click)="okImportClients()" type="button" class="btn btn-primary">Ok</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--video MODAL end-->

<!--Announcements Modal-->
<div id="announcementsModal" class="modal top-right fade fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Announcements</h2>
                <button type="button" (click)="hideAnnouncementsModal()" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div>
                    <!--<div *ngFor="let announcement of announcements" class="alert alert-info" role="alert"></div>-->
                    <!--<ul style="list-style-type: none;">
                        <li *ngFor="let announcement of announcements">{{announcement.Text}}</li>
                    </ul>-->

                    <!--[ngClass]="{'carousel': displayNextBack}"--> 
                    <section>
                        <div class="announcement_wrap" >
                            <div class="announcemente_content">
                                {{currentAnnouncement}}
                            </div>
                            <div class="carousel__snapper">
                                <a *ngIf="displayBackArrow" class="lefttWrap" (click)="prevAnnouncement()"><i class="fas fa-chevron-left"></i></a>
                                <a *ngIf="displayNextArrow" class="rightWrap" (click)="nextAnnouncment()"><i class="fas fa-chevron-right"></i></a>
                                <!--[ngClass]="{'carousel__prev': displayBackArrow}"-->
                                <!--[ngClass]="{'carousel__next': displayNextArrow}"-->
                            </div>
                        </div>
                    </section>

                </div>
            </div>

            <div class="modal-footer">
                <div class="">
                    <div class="col-md-12">
                        <button (click)="hideAnnouncementsModal()" type="button" class="btn btn-secondary">Close</button>
                        <!--<button (click)="okImportClients()" type="button" class="btn btn-primary">Ok</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>